var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from 'styled-components';
import { variant, justifyContent, margin } from 'styled-system';
export var StyledContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
export var StyledTabsWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  ", ";\n  ", ";\n\n  ", "\n\n  ", "\n\n    ", "\n"], ["\n  display: flex;\n  ", ";\n  ", ";\n\n  ",
    "\n\n  ",
    "\n\n    ",
    "\n"])), justifyContent, margin, function (props) {
    return props.variant === 'default' &&
        "background-color: " + props.theme.color.background + "; \n    border-radius: 4px; \n    height: 40px; \n    align-items: center; \n    padding: 4px;\n    ";
}, function (props) {
    return props.variant === 'scheduled' &&
        "border-top: 1px solid " + props.theme.color.grey1 + "; \n    height: 68px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    ";
}, function (props) {
    return props.variant === 'block' &&
        " overflow-x: auto;\n      overflow-y: hidden;\n      ";
});
var activeCategoryTab = function (isActive, theme) { return (isActive ? theme.color.white : theme.color.headlineText); };
var activeDefaultTab = function (isActive, theme) { return (isActive ? theme.color.white : theme.color.headlineText); };
var activeUnderlinedTab = function (isActive, theme) { return (isActive ? theme.color.black : theme.color.grey0); };
export var StyledTab = styled.span(function (props) {
    return variant({
        prop: 'variant',
        variants: {
            category: {
                '& label': {
                    color: props.isDisabledTab ? props.theme.color.disabled : activeCategoryTab(props.isActiveTab, props.theme),
                    lineHeight: 'normal',
                    whiteSpace: 'nowrap',
                    textAlign: 'center',
                    fontSize: props.theme.fontSizes.body1,
                },
                background: props.isActiveTab ? props.theme.color.primary : props.theme.color.background,
                padding: props.theme.space[2] + "px " + props.theme.space[3] + "px",
                margin: "0 " + props.theme.space[1] + "px",
                borderRadius: '50px',
                height: '36px',
            },
            default: {
                '& label': {
                    color: props.isDisabledTab ? props.theme.color.disabled : activeDefaultTab(props.isActiveTab, props.theme),
                    fontSize: '14px',
                    lineHeight: '20px',
                    fontWeight: 'normal',
                },
                textAlign: 'center',
                cursor: 'pointer',
                textTransform: 'capitalize',
                whiteSpace: 'nowrap',
                backgroundColor: props.isActiveTab && props.theme.color.primary,
                borderRadius: '4px',
                height: '32px',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                flex: 1,
            },
            scheduled: {
                height: '68px',
                display: 'flex',
                alignItems: 'center',
                backgroundColor: props.isActiveTab ? props.theme.color.grey1 : props.theme.color.white,
                width: '100%',
                justifyContent: 'center',
                flexWrap: 'wrap',
                padding: '14px',
            },
            block: __assign(__assign({ '& label': {
                    color: props.isDisabledTab ? props.theme.color.disabled : props.theme.color.black,
                    opacity: !props.isActiveTab && '0.5',
                }, cursor: 'pointer', textTransform: 'capitalize', height: '66px', display: 'flex', flexDirection: 'column', flex: 1, alignItems: 'center', backgroundColor: props.isActiveTab ? "" + props.theme.color.primary10 : props.theme.color.headlineText + "0D", justifyContent: 'center', textAlign: 'center', padding: props.theme.space[4] + "px 0", borderRadius: props.theme.space[2] + "px" }, (props.isActiveTab && { border: "1px solid " + props.theme.color.primary })), { marginInlineEnd: props.theme.space[4] + "px", minWidth: '145px' }),
            underlined: {
                '& label': {
                    color: props.isDisabledTab
                        ? props.theme.color.disabled
                        : activeUnderlinedTab(props.isActiveTab, props.theme),
                    fontSize: props.theme.fontSizes.body1,
                    lineHeight: '26px',
                    fontWeight: props.theme.fontWeights.semiBold,
                },
                cursor: 'pointer',
                textTransform: 'capitalize',
                whiteSpace: 'nowrap',
                backgroundColor: props.theme.color.white,
                borderBottom: props.isActiveTab && "solid 3px " + props.theme.color.primary,
                height: '50px',
                display: 'flex',
                flex: 1,
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
            },
        },
    });
}, function (props) {
    return { cursor: props.isDisabledTab ? 'default' : 'pointer', textTransform: 'capitalize' };
});
var templateObject_1, templateObject_2;
